import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';
import { claimEntryScreenUrl,providerUrl,patientSetupScreenUrl } from '../../lib/OfficeMdUrls';

export function hideWindowObject(object_id : string) : void {
    const loadingMessageElement: HTMLElement | null = document.getElementById(object_id);

    if (loadingMessageElement) {
        loadingMessageElement.style.display = "none";
    }
} 
export function openLegacyWindowFromVuew(window_id: string, window_value : string | number | undefined) : void {
    if (window_value) {
        switch (window_id) {
            case "ClaimEntry":
                openWindowFromVue("ClaimEntry", claimEntryScreenUrl(window_value), { noTimestamp:"N"});
                break;
            case "Provider":    
                openWindowFromVue("Provider", providerUrl(window_value), { noTimestamp:"N"});
                break;
            case "PatientSetup":
                const patient_url = patientSetupScreenUrl(DatabaseIdTypes.patient_id, window_value);
                if (patient_url) {
                    openWindowFromVue("NewPatient",patient_url, { noTimestamp:"N"});
                }
                break;
        }
    }

}
export function openWindowFromVue(windowID : string, windowUrl: string, windowJson : object | undefined) : void {
    const open_function = checkWindowFunctionWithArgs<() => void>('window_open',false);
    if (open_function) { 
        open_function(windowID, windowUrl, false,windowJson);
    }
}  
export function checkWindowFunction<T extends Function>(functionName: string, parentWindow: boolean): T | undefined {
    if (!parentWindow) 
        return (window as any)[functionName] as T | undefined;
    else 
        return (parent.window as any)[functionName] as T | undefined;
}
// Not gonna lie, this came from ChatGPT (second response as first was in error...)
export function checkWindowFunctionWithArgs<T extends (...args: any[]) => any>(functionName: string,parentWindow: boolean, ...args: Parameters<T> ): ((...args: any[]) => any) | undefined {
    const fn = (parentWindow ? (parent.window as any)[functionName] as T | undefined : (window as any)[functionName] as T | undefined);
    return fn ? fn.bind(window, ...args) : undefined;
}

